import React from 'react'

import Link from 'app/components/base/Link'
import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import { useGetHelpCenterArticles } from 'app/services/Query/help-center/help-center.query'
import { HELP_CENTER_SEARCH_ARTICLES_PLACEHOLDER } from 'app/utils/constants/help-center.constants'

import HelpCenterTitle from '../components/HelpCenterTitle'
import { useGetCategoriesData } from '../hooks/useGetCategoriesData'

interface HelpCenterArticlesFeatureProps {
  categorySlug: string
  subcategorySlug?: string
  isLoading?: boolean
}

const HelpCenterArticlesFeature = ({
  categorySlug,
  subcategorySlug,
  isLoading
}: HelpCenterArticlesFeatureProps) => {
  const byCategory = subcategorySlug || categorySlug

  const { data } = useGetHelpCenterArticles({
    params: { byCategory },
    options: {
      enabled: false,
      placeholderData: HELP_CENTER_SEARCH_ARTICLES_PLACEHOLDER
    }
  })

  const { categoryName, subcategoryName } = useGetCategoriesData({
    categorySlug
  })

  const articles = data?.articles
  const showArticles = Number(articles?.length) > 0
  const title = subcategoryName || categoryName

  return (
    <Stack direction="column" spacing={1} sx={{ width: '100%' }}>
      <HelpCenterTitle title={title} isLoading={isLoading} />

      {showArticles &&
        articles?.map((item) => (
          <Skeleton
            key={item.id}
            loading={isLoading}
            sx={{ width: { xs: '100%', md: '80%' }, height: 24 }}
          >
            <Link
              href={`/help-centre/${item.primary_help_center_category?.slug}/${item.slug}`}
            >
              {item.title}
            </Link>
          </Skeleton>
        ))}
    </Stack>
  )
}

export default HelpCenterArticlesFeature
